module.exports = __webpack_public_path__ + "static/media/rsz_massan-122.c167d1bd.jpg";